module.exports = __webpack_public_path__ + "media/images/camden_24c-b9122c74.png";